import React from 'react';

import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { GenerationComparisonBlock } from '../../report/GenerationImpactProjectionBlocks';

/**
 * The candidate set the promoted scenario was chosen FROM.
 *
 * Promotion is a funnel to exactly one authority, and before the comparison was
 * carried into the report that funnel also destroyed the fact that a comparison
 * had happened: a reader could not tell whether one configuration had been
 * considered or four. This section is where that record surfaces with its own
 * table-of-contents line, so "we screened these and here is why they lost" is a
 * findable part of the document rather than a paragraph inside another section.
 *
 * Optional by construction — `GenerationComparisonBlock` renders nothing unless
 * two or more configurations were recorded, and the router omits this section
 * (and its TOC entry) in that case, so a single-scenario report is unchanged.
 */
export const GenerationScenarioComparisonSection: React.FC<{
  report: SiteRagReport;
  label: string;
}> = ({ report, label }) => {
  const rows = report.generationImpactProjection?.comparison?.rows.length ?? 0;
  return (
    <SectionShell label={label} hasData={rows >= 2}>
      <GenerationComparisonBlock report={report} />
    </SectionShell>
  );
};
